import { selectors } from '@elab/core/store/order';
import connect from '@elab/core/store/connect';
import { DeliveryAddress } from '@elab/components/connected/DeliveryAddress';
import { selectors as configSelectors } from '@elab/core/store/config';

const mapStateToProps = state => ({
    deliveryAddress: selectors.getPaymentAddress(state),
    showCorporateOptionFields: configSelectors.getShowCorporateOptionFields(state),
});

export default () =>
    customElements.define('e2-order-payment-address', connect(mapStateToProps)(DeliveryAddress));
